import Landing from "./Content/Landing";
import About from "./Content/About";
import Services from "./Content/Services";
import Contact from "./Content/Contact";
import NousRejoindre from "./Content/NousRejoindre";
import Confiance from "./Content/Confiance";
import AnchorNav from "../Carrieres/components/AnchorNav.jsx";
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const SECTIONS = [
  { id: "section-accueil",       labelKey: "anchor_accueil" },
  { id: "section-quisommesnous", labelKey: "anchor_quisommesnous" },
  { id: "section-services",      labelKey: "anchor_services" },
  { id: "section-confiance",     labelKey: "anchor_confiance" },

  { id: "section-rejoindre",     labelKey: "anchor_rejoindre" },
];

export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t("home_home")}</title>
        <link rel="canonical" href="https://www.ormaes.fr/" />
      </Helmet>
      <AnchorNav SECTIONS={SECTIONS}/>
      <section id="section-accueil" className="scroll-mt-24"><Landing /></section>
      <section id="section-quisommesnous" className="scroll-mt-24"><About /></section>
      <section id="section-services" className="scroll-mt-24"><Services /></section>
      <section id="section-confiance" className="scroll-mt-24"><Confiance /></section>
      <Contact />
      <section id="section-rejoindre" className="scroll-mt-24"><NousRejoindre /></section>
    </>
  );
}